import { render, staticRenderFns } from "./MachinesReportsView.vue?vue&type=template&id=45707d00&"
import script from "./MachinesReportsView.vue?vue&type=script&lang=js&"
export * from "./MachinesReportsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "MachinesReportsView.vue"
export default component.exports